import { render, staticRenderFns } from "./shipmentCharges.vue?vue&type=template&id=5070a86c&scoped=true"
import script from "./shipmentCharges.vue?vue&type=script&lang=js"
export * from "./shipmentCharges.vue?vue&type=script&lang=js"
import style0 from "./shipmentCharges.vue?vue&type=style&index=0&id=5070a86c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5070a86c",
  null
  
)

export default component.exports